import styled from 'styled-components';

export const Top = styled.section`
  background-color: ${({ theme }) => theme.colors.grey[100]};
  padding: 36px 0;
  color: ${({ theme }) => theme.colors.grey.black};

  > div {
    flex-direction: row;
    justify-content: space-between;

    @media ${({ theme }) => theme.devices.tablet} {
      flex-direction: column;
      align-items: center;
    }
  }

  .desktop {
    @media ${({ theme }) => theme.devices.tablet} {
      display: none;
    }
  }

  .mobile {
    display: none;
    width: 100%;

    @media ${({ theme }) => theme.devices.tablet} {
      display: flex;
    }
  }
`;

export const GroupAbout = styled.div`
  width: 33%;
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
  }

  h2 {
    font-family: 'Anton', sans-serif;
    text-transform: uppercase;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 24px;
    }
  }

  p {
    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 16px;
    }
  }

  .links {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 16px;

    img {
      width: 100%;
      /* background-color: red; */
      max-width: 36px;

      @media ${({ theme }) => theme.devices.mobile} {
        max-width: 28px;
      }

      &:hover {
        transition: 0.7s;
        opacity: 0.8;
      }
    }
  }
`;

export const GroupNav = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  border-left: 1px solid ${({ theme }) => theme.colors.grey.black};

  @media ${({ theme }) => theme.devices.mobile} {
    border-left: 0;
    padding: 0;
    gap: 10px;
    margin-top: 10px;

    & + & {
      border-left: 1px solid ${({ theme }) => theme.colors.grey.black};
    }
  }

  span {
    width: 100%;
    max-width: 220px;

    b {
      font-weight: 700;
    }
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    padding: 4px 0;
    font-weight: 300;
    color: ${({ theme }) => theme.colors.grey.black};
    gap: 8px;

    @media ${({ theme }) => theme.devices.mobile} {
      width: fit-content;
      justify-content: flex-start;
      font-size: 14px;
      padding: 4px 8px;
      gap: 4px;
    }

    svg {
      width: 24px;
      color: ${({ theme }) => theme.colors.grey.black};

      @media ${({ theme }) => theme.devices.mobile} {
        width: 16px;
      }
    }

    &:hover {
      transition: 0.7s;
      color: ${({ theme }) => theme.colors.primary.main};

      svg {
        transition: 0.7s;
        color: ${({ theme }) => theme.colors.primary.main};
      }
    }
  }

  .link {
    width: 100%;
    max-width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 28px;
    background-color: ${({ theme }) => theme.colors.primary.main};
    border-radius: 32px;

    @media ${({ theme }) => theme.devices.mobile} {
      max-width: 100%;
    }

    p {
      font-family: 'Anton', sans-serif;
      text-transform: uppercase;
      color: ${({ theme }) => theme.colors.grey.white};

      @media ${({ theme }) => theme.devices.mobile} {
        font-size: 16px;
      }
    }

    &:hover {
      transition: 0.7s;
      background-color: ${({ theme }) => theme.colors.primary.light};
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%;
  }
`;
